// extracted by mini-css-extract-plugin
export default {"control":"InvoiceSortFilter_control__I+wqJ","text":"InvoiceSortFilter_text__Y3yIw"};